import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import { Quizz } from 'nm-react-quiz';

import WavyLayout from './../../hoc/WavyLayout/WavyLayout';

export class Quiz extends Component {

    handleClick = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    }

    render(){

        let quizz = (<Quizz quizzId="-LFbtR1JQaUJcFNiNDjx" />);

        return(
            <WavyLayout
                page="quizz"
                title="Quiz"
                handleClick={this.handleClick}>
                {quizz}  
            </WavyLayout>
        );
    }
}

const mapStateToProps = state => {
    return {
        chatroomId: state.chatroom.chatroomId
    }
};

export default connect( mapStateToProps )(Quiz);




// WEBPACK FOOTER //
// ./src/containers/Quiz/Quiz.js